// General
import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Styles
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ItineraryContainer.css';

// Component
import Itinerary from '../../components/Itinerary';
import Loader from '../../components/Loader';

// Graphql
import getItineraryQuery from './getItineraryQuery.graphql';
import NotFound from '../notFound/NotFound';
import { withQuery } from '../../hoc/withGraphql';

const ItineraryContainer = (props) => {

  const { itineraryData: { loading, getItinerary } } = props;
  if (!loading && !getItinerary) {
    return <NotFound />
  }
  if (loading) {
    return (
      <>
        <Loader type={"text"} show={loading} />
      </>
    );
  }

  return (
    <>
      <Itinerary data={getItinerary} />
    </>
  );
}

ItineraryContainer.propTypes = {
  reservationId: PropTypes.number.isRequired,
  itineraryData: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    getItinerary: PropTypes.object.isRequired
  })
};

ItineraryContainer.defaultProps = {
  itineraryData: {
    loading: true,
  }
};
export default compose(
  withStyles(s),
  withQuery(getItineraryQuery,
    {
      name: 'itineraryData',
      options: (props) => ({
        variables: {
          reservationId: props.reservationId,
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(ItineraryContainer);